module.exports = __webpack_public_path__ + "img/pin-off.addc500f.svg";